import React, { PureComponent } from "react";

class Widget extends PureComponent {
  render() {
    const { title } = this.props;
    return <div>{title}</div>;
  }
}

export default Widget;
